var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSuccess64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.9999999,-9.37500033e-08 C13.4314575,-9.37500033e-08 -9.37500104e-08,13.4314575 -9.37500104e-08,29.9999999 C-9.37500104e-08,46.5685425 13.4314575,59.9999999 29.9999999,59.9999999 C46.5685425,59.9999999 59.9999999,46.5685425 59.9999999,29.9999999 C59.9999999,13.4314575 46.5685425,-9.37500033e-08 29.9999999,-9.37500033e-08 Z M46.9800001,23.18 L27.18,42.98 C26.429727,43.7311082 25.411637,44.1531467 24.35,44.1531467 C23.288363,44.1531467 22.270273,43.7311082 21.52,42.98 L18.68,40.14 L13.0199999,34.48 C12.0089383,33.4689384 11.6140738,31.995284 11.9841481,30.6141481 C12.3542223,29.2330122 13.4330122,28.1542223 14.8141481,27.7841481 C16.1952839,27.4140739 17.6689383,27.8089384 18.68,28.82 L24.34,34.48 L41.32,17.52 C42.8829659,15.9570342 45.4170342,15.9570342 46.98,17.52 C48.5429658,19.0829658 48.5429659,21.6170341 46.9800001,23.18 L46.9800001,23.18 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CBA-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconSuccess64"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons/32/iconStatusApprove32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -2.000000)",
    id: "\\uD83C\\uDFA8-color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83C\\uDFA8-Colour/brand/green",
    fill: "#5AE18C",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess64);
export default __webpack_public_path__ + "static/media/iconSuccess64.41c60c3c96ebb5084a93a72c8b471f10.svg";
export { ForwardRef as ReactComponent };